/* Layout */
import Layout from '../../views/layout/Layout.vue'

const BannerList = () => import(/* webpackChunkName: "banner-list" */ '@/views/banner/list')
const BannerDetail = () => import(/* webpackChunkName: "banner-detail" */ '@/views/banner/detail')

export default [
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/list',
    name: 'Banner',
    alwaysShow: true,
    meta: {
      title: 'banner',
      icon: 'images',
    },
    children: [
      {
        path: 'create',
        component: BannerDetail,
        name: 'BannerCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'banner',
        },
      },
      {
        path: 'edit/:id',
        component: BannerDetail,
        props: true,
        name: 'BannerEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'banner',
        },
      },
      {
        path: 'list',
        component: BannerList,
        name: 'BannerList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'banner',
        },
      },
    ],
  },
]
